import { useMemo } from 'react';
import { CheckoutOrderFragment, LoginType, useAccountExistenceQuery } from '@websky/graphql';

interface Props {
	login?: string;
	customer?: CheckoutOrderFragment['customer'];
	isAuthorized: boolean;
}

export const useCustomerInfo = ({ login, isAuthorized, customer }: Props) => {
	const { data, loading } = useAccountExistenceQuery({
		variables: {
			params: {
				login,
				loginType: LoginType.Email
			}
		},
		skip: !login || isAuthorized
	});

	const isAccountExist = !loading && !!data?.AccountExistence?.result;

	const isSubscribed = customer?.subscribed;
	const isShowSubscribeCheckbox = customer?.showSubscribeCheckbox;

	const showSubscribedCheckbox = useMemo(() => {
		return isShowSubscribeCheckbox;
	}, [isAuthorized, isAccountExist, isShowSubscribeCheckbox]);

	return {
		isAccountExist,
		isSubscribed,
		showSubscribedCheckbox
	};
};
